var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_2573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9043 9.36035C14.1445 9.78223 14.3232 10.2217 14.4404 10.6787C14.5576 11.1357 14.6191 11.6074 14.625 12.0938V12.999L9 15.8203L3.375 12.999C3.375 12.6475 3.37793 12.3193 3.38379 12.0146C3.38965 11.71 3.41602 11.4141 3.46289 11.127C3.50977 10.8398 3.58008 10.5527 3.67383 10.2656C3.76758 9.97852 3.9082 9.67676 4.0957 9.36035L2.25 8.4375V13.5967C2.41992 13.6553 2.57227 13.7373 2.70703 13.8428C2.8418 13.9482 2.96191 14.0713 3.06738 14.2119C3.17285 14.3525 3.24902 14.5049 3.2959 14.6689C3.34277 14.833 3.36914 15.0059 3.375 15.1875V18H0V15.1875C0 15.0117 0.0263672 14.8418 0.0791016 14.6777C0.131836 14.5137 0.208008 14.3584 0.307617 14.2119C0.407227 14.0654 0.524414 13.9424 0.65918 13.8428C0.793945 13.7432 0.949219 13.6611 1.125 13.5967V7.875L0 7.3125L9 2.8125L18 7.3125L13.9043 9.36035ZM2.25 15.1875C2.25 15.0352 2.19434 14.9033 2.08301 14.792C1.97168 14.6807 1.83984 14.625 1.6875 14.625C1.53516 14.625 1.40332 14.6807 1.29199 14.792C1.18066 14.9033 1.125 15.0352 1.125 15.1875V16.875H2.25V15.1875ZM2.51367 7.3125L9 10.5557L15.4863 7.3125L9 4.06934L2.51367 7.3125ZM13.5 12.3047C13.5 11.8535 13.4561 11.4346 13.3682 11.0479C13.2803 10.6611 13.125 10.2656 12.9023 9.86133L9 11.8125L5.09766 9.86133C4.9043 10.2012 4.75781 10.5586 4.6582 10.9336C4.55859 11.3086 4.50586 11.6953 4.5 12.0938V12.3047L9 14.5547L13.5 12.3047Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_2573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.0c8608f0d1bebe88d1ed40fec379551c.svg";
export { ForwardRef as ReactComponent };